import { Box, Skeleton, Stack } from '@mui/material';

export type TableSkeletonProps = {
  rows?: number;
};

export const TableSkeleton = ({ rows = 5 }: TableSkeletonProps) => {
  return (
    <Box sx={{ padding: 2 }}>
      {Array.from(new Array(rows)).map((_, index) => (
        <Stack
          key={index}
          direction="row"
          spacing={2}
          sx={{
            alignItems: 'center',
            marginBottom: 2,
          }}
        >
          <Skeleton variant="rectangular" width="100%" height={40} />
        </Stack>
      ))}
    </Box>
  );
};
